import type {TJoyIconsNames} from '@maltjoy/core-vue';

export enum MenuItemStatus {
    LOCKED = 'LOCKED',
    WAITING = 'WAITING',
    VALID = 'VALID',
    INVALID = 'INVALID',
}

export interface MenuItemLink {
    icon: TJoyIconsNames | null;
    name: string;
    routeName: string;
    status?: MenuItemStatus;
}
